<template>
  <div
    class="grid grid-cols-1 lg:grid-cols-2 gap-5 place-items-center items-center lg:place-items-stretch place-content-center md:h-screen mt-5 md:mt-0"
  >
    <section v-if="!hasSend" class="w-full sm:w-auto lg:w-full">
      <div class="bg-white shadow-md rounded-xl overflow-hidden lg:m-10">
        <div class="bg-gray-50 p-5">
          <h4>
            {{
              $t("labels.generic", {
                pt: "Registre-se como aluno",
                en: "Register as a student",
              })
            }}
          </h4>
        </div>
        <form @submit.prevent="sendEmailToUser()">
          <div class="px-5 py-5">
            <div class="flex flex-col my-4">
              <InputText
                id="email-input"
                type="text"
                v-model="form.email"
                placeholder="E-mail"
                :class="v$.form.email.$error ? 'p-invalid' : ''"
              />
              <Errors :errors="v$.form.email.$errors" />
            </div>
            <div class="flex justify-start flex-wrap gap-1">
              <label for="binary" class="font-[600]">
                {{
                  $t("labels.generic", {
                    pt: "Já tem uma conta? Faça o",
                    en: "Already have an account?",
                  })
                }}
              </label>
              <a
                @click="go.redirectTo('sign-in')"
                class="text-h-primary-500 hover:text-h-primary-700 cursor-pointer font-[700]"
              >
                Login
              </a>
            </div>
          </div>

          <div
            class="bg-gray-50 p-4 flex justify-end items-center mt-3 border-t border-t-gray-300 rounded-b-lg"
          >
            <Button type="submit" label="Enviar" class="btn-primary" />
          </div>
        </form>
      </div>
    </section>

    <section v-if="!hasSend" class="hidden lg:flex justify-end lg:m-14">
      <ComputerComponent icon="md-assignmentind-twotone" />
    </section>

    <section v-else id="email-send-section" class="col-span-12">
      <div class="flex justify-center items-center">
        <div
          class="bg-white shadow-sm rounded-md border border-gray-300 md:w-3/6"
        >
          <div class="bg-gray-50 border-b border-gray-300 p-4">
            <h4>
              {{
                $t("labels.generic", {
                  pt: "Registre-se como aluno",
                  en: "Register as a student",
                })
              }}
            </h4>
          </div>
          <div class="flex flex-col justify-center items-center gap-3 my-10">
            <img
              src="@/assets/images/email.svg"
              class="h-72 w-100"
              alt="login-img"
            />
            <p class="px-8 md:px-10">
              {{
                $t("labels.generic", {
                  pt: "Uma solicitação para completar o seu cadastro foi enviada para o seu e-mail. Por favor, verifique a sua caixa de entrada.",
                  en: "A request to complete your registration has been sent to your email. Please check your inbox.",
                })
              }}
            </p>
          </div>
          <div
            class="bg-gray-50 flex justify-end items-center mt-3 border-t border-t-gray-300 rounded-b-lg p-8"
          ></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { email, required } from "@/locale/locale.config";
import { SignUp } from "@/models/auth.model";
import { AuthRest } from "@/services/rest/auth.rest";
import { GoToRoute } from "@/utils/go-to.util";
import useVuelidate from "@vuelidate/core";
import { defineAsyncComponent, defineComponent } from "vue";

const ComputerComponent = defineAsyncComponent(
  () => import("../Login/computer-component.vue")
);

export default defineComponent({
  name: "signUp",
  components: { ComputerComponent },
  computed: {
    rest(): AuthRest {
      return new AuthRest();
    },
    go(): GoToRoute {
      return new GoToRoute();
    },
  },
  data() {
    return {
      form: new SignUp(),
      hasSend: false as boolean,
    };
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      form: {
        email: { required, email },
      },
    };
  },
  methods: {
    sendEmailToUser(): void {
      this.v$.form.$touch();
      if (!this.v$.form.$error) {
        this.rest.signUpUser(this.form).subscribe({
          next: () => {
            this.redirectToLogin();
          },
        });
      }
    },

    redirectToLogin(): void {
      this.hasSend = true;
      setTimeout(() => {
        this.go.redirectTo("sign-in");
      }, 5000);
    },
  },
});
</script>

<style lang="scss">
#custom-login-svg {
  svg,
  path {
    width: 100%;
    height: 300px;
    @apply fill-current #{!important};
  }
}
</style>
